var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M45.5 0L48.3606 28.3576L60.2738 2.46532L53.7717 30.2152L73.4467 9.59411L58.2865 33.7292L83.5911 20.6139L61.4156 38.5188L89.6077 34.3304L62.8201 44.0648L90.8446 49.2574L62.3476 49.7664L87.1677 63.7771L60.0495 55.0057L78.9754 76.3163L56.1747 59.2148L67.1556 85.5161L51.1431 61.9378L52.9891 90.3794L45.5 62.8795L38.0109 90.3794L39.8569 61.9378L23.8444 85.5161L34.8253 59.2148L12.0246 76.3163L30.9505 55.0057L3.83231 63.7771L28.6524 49.7664L0.155407 49.2574L28.1799 44.0648L1.39229 34.3304L29.5844 38.5188L7.40892 20.6139L32.7135 33.7292L17.5533 9.59411L37.2283 30.2152L30.7262 2.46532L42.6394 28.3576L45.5 0Z",
    fill: "#F7971E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.f2428361090dc42bca9fb7104b5e2765.svg";
export { ForwardRef as ReactComponent };